import type { SvgIconComponent } from '@mui/icons-material'
import type { FC } from 'react'
import { Box, Button, Typography } from '@mui/material'
import FileCopyOutlined from '@mui/icons-material/FileCopyOutlined'

import { copyToClipboard } from '~/shared/lib/clipboard'

interface PatientDetailPopoverLineProps {
  value: string
  icon: SvgIconComponent
}

const PatientDetailPopoverLine: FC<PatientDetailPopoverLineProps> = props => {
  return (
    <Button
      fullWidth
      onClick={() => copyToClipboard(props.value)}
      sx={{ textTransform: 'none', textAlign: 'left', '&:hover *': { opacity: 1 } }}
    >
      <props.icon fontSize="small" />
      <Box sx={{ mx: 1, flex: 1 }}>
        <Typography align="left" variant="caption" component="pre">
          {props.value}
        </Typography>
      </Box>
      <FileCopyOutlined color="action" fontSize="small" sx={{ opacity: 0 }} />
    </Button>
  )
}

export default PatientDetailPopoverLine
